import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW0E00Component } from './kymw0e00.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetChangeInfoService } from './api-services/get-change-info.service';

/**
 * 使用ページ確認画面 モジュール設定クラス
 *
 * @export KYMW0E00Module
 * @class KYMW0E00Module
 */
@NgModule({
  imports: [
    CommonModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW0E00Component,
  ],
  providers: [
    GetChangeInfoService,
  ],
})

export class KYMW0E00Module { }
